import React, { Fragment, useEffect, useState } from 'react';
import { Form, Card, Table } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { serviceGetDestinatarios } from '../../../../api/api-confirmar-cierre';
import { FaPlusSquare, FaSyncAlt, FaEdit } from "react-icons/fa";
import AddDestinatario from './add-destinatario';
import { LoadingComponent } from 'recupero-comunes';

const Destinatario = ({ cfg_form, idSolicitud, idMotivo }) => {
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;
    const [loading, setLoading] = useState(false);
    const [destinatarioSelect, setDestinatarioSelect] = useState(null);
    const [destinatarios, setDestinatarios] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [destinatarioTO, setDestinatarioTO] = useState(null);
    const [handleSubmit, setHandleSubmit] = useState(false);

    useEffect(() => {
        getDestinatarios();
        setHandleSubmit(false);
    }, [handleSubmit])

    const getDestinatarios = async () => {
        setLoading(true);
        let query = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso, concepto: 269 })).toString('base64');
        const response = await serviceGetDestinatarios(query);

        setDestinatarios(response);
        setLoading(false);
        validationClasificaDestino(response);
    }

    const handleAddMod = (destinatario) => {
        setShowModal(true);
        setDestinatarioSelect(destinatario);
    }

    const validationClasificaDestino = (data) => {
        let idDestinatario = null;
        data?.forEach(d => { if (d.codClasDestino === 270001) idDestinatario = d.id; })

        setDestinatarioTO(idDestinatario)
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />

            <div className='mt-2 mb-3'>
                <h6>{cfg_form && cfg_form["modalconfirmarcierre-subtitledestinatarios"]}</h6>

                <Card className='mt-1'>
                    <Table striped hover>
                        <thead style={{ backgroundColor: '#4F517A', color: 'white' }}>
                            <tr>
                                <th style={{ fontSize: '14px' }}>{cfg_form && cfg_form["modalconsultacierre-grilladest-tipo"]}</th>
                                <th style={{ fontSize: '14px' }}>{cfg_form && cfg_form["modalconsultacierre-grilladest-destinatario"]}</th>
                                <th style={{ textAlign: 'center', fontSize: '14px' }}>{cfg_form && cfg_form["modalconsultacierre-grilladest-clasdestino"]}</th>
                                <th style={{ fontSize: '14px' }}>{cfg_form && cfg_form["modalconsultacierre-agregadest-email"]}</th>
                                <th style={{ textAlign: 'center', fontSize: '14px', width: '8%' }}>
                                    <FaSyncAlt
                                        size={20}
                                        color='white'
                                        title="Reload Destinatarios"
                                        style={{ marginRight: '8px', cursor: 'pointer' }}
                                        onClick={getDestinatarios}
                                    />
                                    <FaPlusSquare
                                        size={20}
                                        color='white'
                                        title="Adicionar Destinatario"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleAddMod(null)}
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {destinatarios && destinatarios.map((pre, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{pre.tipoDestinatario}</td>
                                        <td>{pre.nombreDestinatario}</td>
                                        <td style={{ textAlign: 'center' }}>{pre.glosaClasDestino}</td>
                                        <td>{pre.emailDestinatario}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <FaEdit className='icon'
                                                size={20}
                                                color='gray'
                                                title="Modificar Destinatario"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleAddMod(pre)}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </Card>
            </div>

            <AddDestinatario
                cfg_form={cfg_form}
                showModal={showModal}
                setShowModal={setShowModal}
                idSolicitud={idSolicitud}
                idMotivo={idMotivo}
                destinatario={destinatarioSelect}
                destinatarioTO={destinatarioTO}
                setHandleSubmit={setHandleSubmit}
            />
        </Fragment>
    )
}

export default Destinatario;